<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Key" class="d-icon d-icon--key" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M10.854.647a.5.5 0 0 1 0 .707L10.207 2l1.147 1.147a.5.5 0 0 1 0 .707l-1.75 1.75a.5.5 0 0 1-.707 0L7.75 4.457 6.376 5.831a3.28 3.28 0 0 1 .638 1.92 3.275 3.275 0 0 1-.952 2.31 3.275 3.275 0 0 1-2.31.952 3.275 3.275 0 0 1-2.302-.968l-.003-.004a3.25 3.25 0 0 1 4.216-4.91L10.147.647a.5.5 0 0 1 .707 0ZM5.346 6.163a2.25 2.25 0 0 0-3.182 3.182c.416.42 1.001.666 1.592.668.592.002 1.18-.24 1.599-.66a2.275 2.275 0 0 0 .659-1.598 2.275 2.275 0 0 0-.668-1.592ZM8.457 3.75l.793.793L10.293 3.5 9.5 2.707 8.457 3.75Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconKey',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
